import { Box } from "@chakra-ui/react";
import { ColorIcon } from "./Icons";
import { colors } from "../styles";
import { HStack } from "./HStack";
import { Image } from "./Image";
import { Spacing } from "./Spacing";
import { VStack } from "./VStack";
import { icon } from "../constants/icon";

interface HomeCardProps {
  imageSrc?: string;
  icon?: {
    name: keyof typeof icon;
    size?: number;
    color?: string;
  };
  title: string;
  buttonText: string;
}

export const HomeCard = ({
  imageSrc,
  icon: iconProps,
  title,
  buttonText,
}: HomeCardProps) => {
  return (
    <VStack
      padding="20px 24px"
      background={colors.gray50}
      borderRadius="12px"
      gap={0}
    >
      {imageSrc && (
        <>
          <Image width="64px" height="64px" src={imageSrc} />
          <Spacing gap={16} />
        </>
      )}
      {iconProps && (
        <>
          <Box
            width="56px"
            height="56px"
            borderRadius="50%"
            background={colors.white}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ColorIcon
              name={iconProps.name}
              size={iconProps.size ?? 24}
              color={iconProps.color ?? ""}
            />
          </Box>
          <Spacing gap={16} />
        </>
      )}
      <Box className="body_18_m gray900" whiteSpace="pre-line">
        {title}
      </Box>
      <Spacing gap={8} />
      <HStack gap="2px">
        <span className="gray700">{buttonText}</span>
        {imageSrc && (
          <Box transform="rotate(180deg)">
            <ColorIcon
              name="arrow_forward_ios"
              color={colors.gray700}
              width={16}
              height={24}
            />
          </Box>
        )}
      </HStack>
    </VStack>
  );
};
